import { Page } from '../organisms';

export function NotFoundPage() {
  return (
    <Page title={null} hideBackButton>
      <p className="text-xl mt-4 font-bold">Ooops!</p>
      <p className="text-base mt-2 mb-4 text-center text-text-secondary">How did that happen?</p>
      <img className="mt-10 max-w-[70vw] max-h-[50vh] rounded-lg shadow-lg" src="/oops.jpg" alt="Not found" />
    </Page>
  );
}
